import React, { useState } from 'react'
import { DobleGuion } from './DobleGuion'
import { EquisIcons } from '../utils/icons'
import './ChangePassUserForm.scss'
import axios from 'axios'
import { connect } from 'react-redux'
import { showPopup } from '../actions'
import { tokerUser } from '../hooks/user';
import md5 from 'md5';
import { comprobarDatos } from '../hooks/validateForm'
import { API } from '../hooks/config'

const ChangePassUserForm = (props) => {
    const { user, clickClose } = props
    const [passwords, setPasswords] = useState({
        passOld: '',
        passNew: '',
        passRepeat: ''
    })

    const reglas = {
        passOld: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        passNew: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        passRepeat: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setPasswords(() => ({
            ...passwords,
            [name]: value
        }))
    }

    const handleSaveNewPassword = () => {
        const alias = {
            passOld: 'contraseña anterior',
            passNew: 'contraseña nueva',
            passRepeat: 'repetir contraseña nueva'
        }
        comprobarDatos(passwords, reglas, alias).then(res => {
            tokerUser().then(res => {
                const tokenUser = res
                const headers = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${tokenUser}`
                    }
                };
                axios.post(`${API}/protected/users-pass`, {
                    id: user.id,
                    passOld: md5(passwords.passOld),
                    passNew: md5(passwords.passNew),
                }, headers).then(res => {
                    props.showPopup({ active: true, message: 'Contraseña modificada', type: 'success' })
                    clickClose()
                }).catch(err => {
                    props.showPopup({ active: true, message: 'Error al cambiar la contraseña', type: 'error' })
                });
            })
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    return (
        <div className="change-pass-user-form-container">
            <div className="content">
                <div className="header">
                    <div className="title">
                        <div className="text">
                            <p>MODIFICAR CONTRASEÑA</p>
                            <DobleGuion />
                        </div>
                        <div className="botones">
                            <button className="pointer" onClick={clickClose}><EquisIcons size={15} /></button>
                        </div>
                    </div>
                </div>
                <div className="form">
                    <div className="input-block">
                        <label htmlFor="passOld">Contraseña anterior:</label>
                        <div className="input">
                            <input type="password" name="passOld" value={passwords.passOld} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="input-block">
                        <label htmlFor="passNew">Contraseña nueva:</label>
                        <div className="input">
                            <input type="password" name="passNew" value={passwords.passNew} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="input-block">
                        <label htmlFor="passRepeat">Repetir contraseña nueva:</label>
                        <div className="input">
                            <input type="password" name="passRepeat" value={passwords.passRepeat} onChange={handleChange} />
                        </div>
                    </div>
                </div>
                <div className="botones">
                    <button className="btn" onClick={handleSaveNewPassword}>Guardar</button>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    showPopup
}

export default connect(null, mapDispatchToProps)(ChangePassUserForm)